import Main from './Main'
import Single from './Single'
import Create from './Create'
import Edit from './Edit'

export default {
  Main,
  Single,
  Create,
  Edit
}



// WEBPACK FOOTER //
// ./src/components/News/index.js